module.exports = __webpack_public_path__ + "img/template2.37d933d4.png";